import React, { Children, FunctionComponent, isValidElement, PropsWithChildren, ReactNode, useContext } from 'react';

import { DeviceType } from '@amzn/monera-app-core';
import { PageContext } from '@amzn/monera-app-core-components';

import { LeftDummyContainer, ParentWrapperContainer, StyledDivider } from '../twister-buy-box/styles';
import { StyledEmwrContainer, StyledMobileEmwrContainer } from './styles';
import { EmwrContainerProps } from './types';

/**
 * Email Me When Ready container
 * @param props
 * @constructor
 */
export const EmwrContainer: FunctionComponent<PropsWithChildren<EmwrContainerProps>> = (props) => {
  const deviceType = useContext(PageContext).deviceType;
  const { children, ...rest } = props;
  if (!hasValidChildElement(children)) {
    return null;
  }
  return deviceType === DeviceType.Mobile || deviceType === DeviceType.MShop ? (
    <>
      <StyledDivider margin={'0px -24px'} />
      <StyledMobileEmwrContainer data-cy={'emwr-container'} {...rest}>
        {children}
      </StyledMobileEmwrContainer>
      <StyledDivider margin={'0px -24px'} />
    </>
  ) : (
    <ParentWrapperContainer>
      <LeftDummyContainer />
      <StyledEmwrContainer data-cy={'emwr-container'} {...rest}>
        {children}
      </StyledEmwrContainer>
    </ParentWrapperContainer>
  );
};

/**
 * Short solution to verify if at least one non-empty child component.
 * The long term solution should check the EMWR slot contents in MoneraService,
 * and pass a props to EmwrContainer to indicate if this needs to render or not.
 * TODO: https://sim.amazon.com/issues/P98323306
 */
const hasValidChildElement = (children: ReactNode) => {
  let hasElement = false;
  Children.forEach(children, (child) => {
    if (!isValidElement(child) || hasElement) {
      return;
    }
    if (child?.props?.state?.html && child.props.state.html !== '') {
      hasElement = true;
    }
  });
  return hasElement;
};
